import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamation } from '@fortawesome/free-solid-svg-icons';

export default function FormIcon({
  icon,
  error,
  validated = false,
  className,
  isOpenForm,
}) {
  return (
    <div
      className={`absolute top-4 right-4 flex h-[30px] w-[30px] items-center justify-center p-1 ${
        isOpenForm ? 'text-v5-neutral-100' : 'text-v5-green-300'
      } ${
        validated
          ? 'bg-v5-green-100'
          : error
          ? 'bg-v5-red-200'
          : isOpenForm
          ? 'bg-v5-neutral-300'
          : 'bg-v5-green-500'
      } rounded-2xl ${className ? className : ''}`}
    >
      {validated ? (
        <FontAwesomeIcon icon="fa-solid fa-check" />
      ) : error ? (
        <FontAwesomeIcon
          icon={faExclamation}
          style={{ color: isOpenForm ? '#fff' : '#462D2C' }}
        />
      ) : (
        icon
      )}
    </div>
  );
}
